import { ScrollView, View } from 'react-native';
import { styles } from './ColorToolOptions.styles';
import { ToolOptionsRendererProps } from '../../../BaseToolbar.types';
import { ToolOptionsProps } from '../ToolOptionsRenderer.types';
import { observer } from 'mobx-react-lite';
import { ColorToolOption } from './color-tool-option/ColorToolOption';
import { useStore } from 'src/contexts/StoreContext';
import { useColorToolOptionsLogic } from './ColorToolOptions.logic';

export const ColorToolOptions = observer((props: ToolOptionsRendererProps<ToolOptionsProps>) => {
  const { i18n } = useStore();
  const { isActive, isPriceVisible } = props;

  const { scrollViewRef, getScrollViewElementTestId, colorOptions, onPressAndSelectToolOption, isOptionSelected } =
    useColorToolOptionsLogic(props);

  return (
    <ScrollView
      style={styles.scrollView}
      ref={scrollViewRef}
      showsVerticalScrollIndicator={true}
      persistentScrollbar={true}
    >
      <View style={[styles.containerToolOptions]}>
        {colorOptions.map((option: ToolOptionsProps, index: number) => {
          return (
            <View key={`color-tool-options-${option?.choiceDetails?.color}`} testID={getScrollViewElementTestId(index)}>
              <ColorToolOption
                index={index}
                isActive={isActive}
                isPriceVisible={isPriceVisible}
                isSelected={isOptionSelected(option)}
                isDisabled={!option?.enabled}
                optionCode={option?.productOptionCode}
                color={option?.choiceDetails?.color}
                onPress={async () => onPressAndSelectToolOption(option)}
                title={option?.titleKey && i18n.t(option?.titleKey)}
                hint={option.hint && i18n.t(option.hint)}
              />
            </View>
          );
        })}
      </View>
    </ScrollView>
  );
});

ColorToolOptions.displayName = 'ColorToolOptions';
